module.exports = __webpack_public_path__ + "img/medal.3b407c7e.webp";